import React, { Component } from 'react';
import { getOwnerContract } from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import Slot from './tree/slot';
import { TransactionService } from '../../services/transactionService';
import abi from "../../abi/owner.json";

class Withdraw extends Component {

    state = {
        usdtBalance: "0"
    };

    withdraw = async () => {
        const wallet = await getWallet();
        if (wallet.isReadOnly) {
            alert("Please connect your wallet");
            return;
        }

        

        const contract = await getOwnerContract();

        await contract.withdraw();
        alert('Successfully amount withdrawn to wallets');
    }
loadUSDTBalance = async () => {
  try {
    const ownerContract = await getOwnerContract();
    const tokenContract = await getTokenContract(); // USDT

    const balance = await tokenContract.balanceOf(
      ownerContract.address
    );

    const formatted = ethers.utils.formatUnits(balance, 18); 
    // ⚠️ ถ้า USDT จริงใช้ 6 decimals → เปลี่ยนเป็น 6

    this.setState({
      usdtBalance: formatted
    });

  } catch (err) {
    console.log(err);
  }
};
async componentDidMount() {
  await this.loadUSDTBalance();
}




    render() {
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                    {/* Top Panel, Matrix levels and all activies inside below div */}
                    <div className="flex flex-col w-full space-y-10 sm:space-y-5">

                        {/* Top panel Partners, Team, Profit ration, Profits View inside below div */}
                        <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                            <div className="flex w-full flex-wrap lg:flex-col">
                                <div
  className="border p-5 rounded-md text-center mb-5"
  style={{
    borderColor: "rgb(15,247,250)",
    borderStyle: "dashed"
  }}
>
  <h3 className="font-bold text-lg mb-2">
    Owner Contract USDT Balance
  </h3>

  <span className="text-xl font-mono">
    {this.state.usdtBalance} USDT
  </span>
</div>



                                <button
                                
                                
                                
                                style={{ background: 'white' }}
                                    className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-10 py-5 !px-10 sm:py-5 sm:mt-7.5"
                                    onClick={this.withdraw} id="nextButton" >Withdraw </button>
                            </div>
                        </div>
                        {/* Top panel Partners, Team, Profit ration, Profits View inside above div */}

                    </div>
                </div>
            </div>
        );
    }
}

export default Withdraw;